import { useQuery } from '@tanstack/react-query';
import { getClaimCorrectionNote } from '@uplift/api';
import { BaseQueryOpts } from '@uplift/queries';


export const useClaimCorrectionNote = (noteId: string, opts?: BaseQueryOpts) => {
  return useQuery({
    queryKey: [ 'claim-correction' ],
    queryFn: async () => {
      const claimCorrectionResponse = await getClaimCorrectionNote(noteId);

      return claimCorrectionResponse.data;
    },
    ...opts
  });
};
